import { render, staticRenderFns } from "./doGrade.vue?vue&type=template&id=bbdae97c&scoped=true"
import script from "./doGrade.vue?vue&type=script&lang=js"
export * from "./doGrade.vue?vue&type=script&lang=js"
import style0 from "./doGrade.vue?vue&type=style&index=0&id=bbdae97c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdae97c",
  null
  
)

export default component.exports